import script from "./PbxSitesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxSitesPanel.vue?vue&type=script&setup=true&lang=js"

import "./PbxSitesPanel.vue?vue&type=style&index=0&id=ca3f3302&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca3f3302"]])

export default __exports__